// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tNKUS","footer":"styles_footer__a8OV5"};